
import React from "react";
import { connect } from "react-redux";
import WithComponent from "./Container";
import { actionLogin, actionCodeLogin } from "./model";

function mapDispatchToProps(dispatch: any) {
    return {
        onLogin: (query: any) => dispatch({ type: actionLogin, payload: query }),
        onCodeLogin: (query: any) => dispatch({ type: actionCodeLogin, payload: query })
    };
}

const LoginComponent = WithComponent({
    mapDispatchToProps
})(React.lazy(() => import("./Login")));

export default connect(null, mapDispatchToProps)(LoginComponent);